export const getCouponsUrl = () => '/agency/coupons';

export const getCouponCodeUrl = () => '/agency/coupons/generate';

export const getCouponUrl = (couponId: string) => `/agency/coupons/${couponId}`;

export const createCouponUrl = () => '/agency/coupons';

export const updateCouponUrl = (couponId: number) => `/agency/coupons/${couponId}`;

export const deleteCouponUrl = (couponId: number) => `/agency/coupons/${couponId}`;
